import React, { useState, useEffect, useCallback } from 'react';
import { Typography } from 'lib/components';
import { Checkbox } from 'lib/components/FormFields';
import { Vendor } from 'types';
import { Timing } from 'lib/util';
import classes from './index.module.scss';
import adjustTime from '../../../adjustTime';
import { useSelectSettings } from '../../../../store';

interface Props {
	vendor: Vendor;
	totalItems: number;
	checkedId: number;
	checkAction: (id: number, isChecked: boolean) => void;
	onRowClick: (vendor: Vendor) => void;
}

const pointerProp = { cursor: 'pointer' };

const AdminRow = ({ vendor, totalItems, checkedId, checkAction, onRowClick }: Props) => {
	const settingsState = useSelectSettings();
	const [checked, setChecked] = useState(false);

	const handleClick = useCallback(() => {
		onRowClick(vendor);
	}, [vendor]);

	useEffect(() => {
		if (checkedId === vendor.id) setChecked(true);
		if (checkedId !== vendor.id || checkedId === -1) setChecked(false);
	}, [checkedId]);

	const handleAction = (e: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(e.target.checked);
		checkAction(vendor.id, e.target.checked);
	};

	return (
		<div key={vendor.id} className={classes['table-row']}>
			<Checkbox
				checked={checked}
				onChange={handleAction}
				style={{
					margin: '0 2rem',
				}}
			/>
			<div className={classes['col']} style={pointerProp} onClick={handleClick}>
				<Typography variant={'h6'}>{vendor.name}</Typography>
			</div>
			<div className={classes['col']} style={pointerProp} onClick={handleClick}>
				<Typography variant={'h6'}>{totalItems} items</Typography>
			</div>
			<div className={classes['col']} style={pointerProp} onClick={handleClick}>
				<Typography variant={'h6'}>{vendor.phoneNumber}</Typography>
			</div>
			<div className={classes['col']} style={pointerProp} onClick={handleClick}>
				<Typography variant={'h6'}>
					{adjustTime(settingsState, vendor.updatedAt).format('MM/DD/YYYY hh:mm A')}
				</Typography>
			</div>
			<div className={classes['col']} style={pointerProp} onClick={handleClick}>
				<Typography variant={'h6'}>
					{adjustTime(settingsState, vendor.createdAt).format('MM/DD/YYYY')}
				</Typography>
			</div>
		</div>
	);
};

export default AdminRow;
